<template>
  <div class="header-actions">
    <LazyLayoutHeaderLangSelector
      :current-locale="currentLocale" 
      :fallback-locale="fallbackLocale"
      @locale-change="$emit('localeChange', $event)"
    />
    <span v-if="supportUrl" class="support-btn">
      <UIButton :href="supportUrl" variant="primary" padding="6px 28px" target="_blank">{{ t('layout.header.actions.supportButton') }}</UIButton>
    </span>
    <StudentUserMenu v-if="devMode" class="student-menu-header" login-variant="icon" />
    <button type="button" class="mobile-toggle" aria-label="Меню" @click="$emit('toggleOffcanvas')">
      <img
      src="/assets/images/icon/gamburger-menu-icon.svg"
      alt=""
      class="mobile-toggle-icon"
      width="24"
      height="24"
      loading="eager"
      decoding="async"
    >
    </button>
  </div>
</template>

<script setup lang="ts">
import { useDevMode } from '@/composables/app/useDevMode'

interface Props {
  currentLocale?: string
  fallbackLocale?: string
}

defineProps<Props>()

const { t } = useI18n()
const config = useAppConfig()
const supportUrl = computed(() => config.site?.supportUrl as string | null ?? null)
const route = useRoute()
const { devMode } = useDevMode()

defineEmits<{
  toggleOffcanvas: []
  localeChange: [locale: string]
}>()
</script>

<style scoped>
.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.mobile-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.mobile-toggle-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

@media (max-width: 1300px) {
  .header-actions :deep(.lang-selector),
  .support-btn,
  .student-menu-header {
    display: none;
  }

  .mobile-toggle {
    display: flex;
  }
}
</style>

